

    module.exports = {
        getBoxLayoutParams: function () {
            return {
                left: this.get('left'),
                top: this.get('top'),
                right: this.get('right'),
                bottom: this.get('bottom'),
                width: this.get('width'),
                height: this.get('height')
            };
        }
    };



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/model/mixin/boxLayout.js
// module id = 1021
// module chunks = 158